<div class="ticketing-admin">
  <!-- Tab strip (mirrors the Settings page tabs) -->
  <div class="ticketing-tabs">
    <div class="tabs-container">
      <button
        *ngFor="let tab of tabs"
        class="tab-button"
        [class.active]="selectedTabId === tab.id"
        (click)="selectTab(tab.id)"
      >
        <i class="fa-solid {{ tab.icon }}"></i>
        <span>{{ tab.label }}</span>
      </button>
    </div>
  </div>

  <!-- Active panel — each child is created only when its tab is selected -->
  <div class="ticketing-panel">
    <izzy-ticket-teams *ngIf="selectedTabId === 'ticket-teams'" [organizationId]="organizationId"></izzy-ticket-teams>
    <izzy-sla-policies *ngIf="selectedTabId === 'sla-policies'" [organizationId]="organizationId"></izzy-sla-policies>
    <izzy-ticket-numbering *ngIf="selectedTabId === 'ticket-numbering'" [organizationId]="organizationId"></izzy-ticket-numbering>
    <izzy-assignment-rules *ngIf="selectedTabId === 'assignment-rules'" [organizationId]="organizationId"></izzy-assignment-rules>
    <izzy-skills *ngIf="selectedTabId === 'skills'" [organizationId]="organizationId"></izzy-skills>
    <izzy-automation-rules *ngIf="selectedTabId === 'automation-rules'" [organizationId]="organizationId"></izzy-automation-rules>
    <izzy-macros *ngIf="selectedTabId === 'macros'" [organizationId]="organizationId"></izzy-macros>
  </div>
</div>
